import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EnvironmentService} from './services/environment.service';
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';



@NgModule({
    declarations: [PreventDoubleClickDirective],
    imports: [
        CommonModule
    ],
    exports: [
        PreventDoubleClickDirective
    ],
    providers: [
        EnvironmentService
    ]
})
export class CoreModule { }
